import { render, staticRenderFns } from "./PageForum.vue?vue&type=template&id=22bec5aa&"
import script from "./PageForum.vue?vue&type=script&lang=js&"
export * from "./PageForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports